import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { UpsertAnimalInput } from "domain/animal/upsertAnimal";

export function useAnimalFieldReset() {
    const { watch, setValue } = useFormContext<UpsertAnimalInput>();

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === "animalTypeId") {
                setValue("breedId", 0);
                setValue("secondaryBreedId", null);
                setValue("colourId", 0);
                setValue("secondaryColourId", null);
            }

            if (name === "breedSelection" && value.breedSelection === "PUREBRED") {
                setValue("secondaryBreedId", null);
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, setValue]);
}
